import ApplicationAdapter from 'register-partners-js/adapters/application';
import { registerBaseURL } from 'register-partners-js/constants/hosts';

export default class RegisterRedirectionTokenAdapter extends ApplicationAdapter {
  host = registerBaseURL;
  namespace = 'v1';

  urlForFindRecord(id) {
    return `${this.host}/${this.namespace}/redirection_tokens/${id}`;
  }
}
